import React, { useState } from 'react';
import useIntl from '@afosto/utils-react/intl/useIntl';
import { useOrderContext } from '../../../../components/OrderProvider';
import { useSnackbar } from 'notistack';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import ProcessForm from './ProcessForm';
import FormDrawer from '@afosto/app-components-react/FormDrawer';
import Property from '@afosto/app-components-react/Property';
import { orders as ordersApi } from '@afosto/order/api/Orders';
import translations from './translations';

const OrderProcessSection = () => {
  const intl = useIntl();
  const [showEditProcessing, setShowEditProcessing] = useState(false);
  const { order, setOrder } = useOrderContext();
  const { enqueueSnackbar } = useSnackbar();
  const { is_locked: isLocked } = order?.state ?? {};
  const { allocation = 'auto', capture = 'auto', confirm = 'auto', fulfilment = 'auto' } =
    order.processing || {};

  const getProcessingValue = value => {
    if (!value) {
      return undefined;
    }

    return intl.formatMessage({
      id: `pages.orderProcessSection.processingOptions.${value}`,
      defaultMessage: value,
      description: 'Label of the processing value',
    });
  };

  const handleChangeProcess = async processingData => {
    try {
      await ordersApi.updateOrderSettings(order?.id, {
        ...order,
        processing: { ...(order?.processing ?? {}), ...processingData },
      });

      enqueueSnackbar(intl.formatMessage(translations.feedback.processSettingsUpdated), {
        variant: 'success',
      });

      setOrder({ ...order, processing: { ...(order?.processing ?? {}), ...processingData } });
      setShowEditProcessing(false);
    } catch (err) {
      enqueueSnackbar(intl.formatMessage(translations.feedback.processSettingsNotUpdated), {
        variant: 'error',
      });
    }
  };

  return (
    <>
      <Card>
        <CardHeader
          title={intl.formatMessage(translations.title)}
          titleTypographyProps={{ variant: 'h6' }}
          action={
            !isLocked && (
              <Button
                color="primary"
                variant="outlined"
                onClick={() => setShowEditProcessing(true)}
              >
                {intl.formatMessage(translations.actions.edit.label)}
              </Button>
            )
          }
        />
        <CardContent>
          <Property
            label={intl.formatMessage(translations.processing.allocation)}
            value={getProcessingValue(allocation)}
          />

          <Property
            label={intl.formatMessage(translations.processing.capture)}
            value={getProcessingValue(capture)}
          />

          <Property
            label={intl.formatMessage(translations.processing.confirm)}
            value={getProcessingValue(confirm)}
          />

          <Property
            label={intl.formatMessage(translations.processing.fulfilment)}
            value={getProcessingValue(fulfilment)}
          />
        </CardContent>
      </Card>
      <FormDrawer
        title={intl.formatMessage(translations.processSettings.title)}
        isOpen={showEditProcessing}
        onClose={() => setShowEditProcessing(false)}
        drawerWidth="400px"
      >
        <ProcessForm
          process={order?.processing}
          onSubmit={handleChangeProcess}
          onCancel={() => setShowEditProcessing(false)}
        />
      </FormDrawer>
    </>
  );
};

export default OrderProcessSection;
